<h1>{{ 'login' | translate }}</h1>
<p class="login-scope">{{ 'login-user-type' | translate }}: {{ scopeLabelKey() | translate }}</p>

<form (submit)="submitUserData($event)">
  <mat-form-field>
    <mat-label translate="email" />
    <input matInput type="email" [formField]="loginForm.email" />
  </mat-form-field>
  <mat-form-field>
    <mat-label translate="password" />
    <input matInput type="password" [formField]="loginForm.password" />
  </mat-form-field>
  <button color="primary" [disabled]="loginForm().invalid()" mat-raised-button type="submit">{{ 'login' | translate }}</button>
</form>
<a (click)="submitScope()">{{ 'forgot-password' | translate }}</a>
